export const FEATURE_FLAGS = {
  NEW_NAVBAR: process.env.REACT_APP_NEW_NAVBAR === 'false' ? false : true,
  DEVICE_SIDEBAR: process.env.REACT_APP_DEVICE_SIDEBAR === 'false' ? false : true,
  NEW_LAYOUT: process.env.REACT_APP_NEW_LAYOUT === 'false' ? false : true,
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === 'true' ? true : false,
  ADMIN_SECTION: process.env.REACT_APP_ADMIN_SECTION === 'false' ? false : true,
  COMPARE_SENSORS: process.env.REACT_APP_COMPARE_SENSORS === 'false' ? false : true,
  // Mixed-sensor-type compare: overlay different sensor types (battery + temp +
  // soil moisture, etc.) on a single compare chart. Off by default until the
  // auto-axis / normalization UX has soaked; single-type compare is unaffected.
  COMPARE_MIXED_SENSORS: process.env.REACT_APP_COMPARE_MIXED_SENSORS === 'true' ? true : false,
  // Downlink remote-control (gates/valves). Off by default: the controllable
  // sensor type is still under design and the backend endpoints don't exist yet,
  // so keep the panel from mounting (and firing /control-capabilities) until ready.
  DEVICE_CONTROL: process.env.REACT_APP_DEVICE_CONTROL === 'true' ? true : false,
}
